export default "__VITE_ASSET__Bcu2b2GZ__"